<div class="form">
  <div class="form-text">
    <input class="form-locked" type="text" [value]="text" disabled />
  </div>
  <div class="form-svg">
    <img src="../../../assets/img/locked.svg" alt="locked" />
  </div>
</div>
